module.exports = __webpack_public_path__ + "static/INR_Logo_FondoBianco_1-65ad1b1cd11430bcc00b2588d0c9facf.svg";